import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const ENV_TYPE = publicRuntimeConfig.ENV_TYPE || 'development';

export const isProd = () => ENV_TYPE === 'production';

export const isProdLike = () => ['production', 'staging', 'oldstaging'].includes(ENV_TYPE);
